import { useScrollCarousel } from "../../hooks/useScrollCarousel";
import { storeAssets } from "../../assets";
import { StoreCarouselNav } from "../StoreCarouselNav";
import styles from "./styles.module.scss";

const results = [
  storeAssets.beforeAfter1,
  storeAssets.beforeAfter2,
  storeAssets.beforeAfter3,
  storeAssets.beforeAfter4,
  storeAssets.beforeAfter5,
  storeAssets.beforeAfter6,
];

export function StoreResults() {
  const { trackRef, prev, next } = useScrollCarousel<HTMLUListElement>();

  return (
    <section className={styles.section} aria-labelledby="store-results-title">
      <span className={styles.eyebrow}>Antes e depois</span>
      <h2 className={styles.title} id="store-results-title">Homens reais que conquistaram cabelos mais densos e fortes em 3 a 6 meses.</h2>
      <p className={styles.description}>
        Os resultados podem variar de acordo com o grau de queda e a constância no tratamento.
        Para melhores resultados, siga o tratamento continuamente e combine fórmulas orais e tópicas.
      </p>

      <ul className={styles.track} ref={trackRef}>
        {results.map((src, index) => (
          <li className={styles.slide} key={src}>
            <img src={src} alt={`Antes e depois do tratamento capilar — paciente ${index + 1}`} width="420" height="420" loading="lazy" decoding="async" />
          </li>
        ))}
      </ul>
      <StoreCarouselNav label="Antes e depois" onPrev={prev} onNext={next} />
    </section>
  );
}
